import {
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider
} from '@mui/material';
import { colors } from '../colors';
import GlobalStyles from './globalStyles';

export default function ThemeConfig({ children }) {
  const themeOptions = {
    palette: {
      mode: 'dark',
      primary: { main: colors.green61 },
      secondary: { main: colors.orange02 },
      white: { main: colors.whiteFF },
      warning: {
        lighter: '#D0ECFE',
        light: '#73BAFB',
        main: '#1877F2',
        dark: '#0C44AE',
        darker: '#042174',
        contrastText: '#FFFFFF'
      },
      lime: {
        lighter: '#E7FEE7',
        light: '#B7F602',
        main: '#B7F602',
        dark: '#B7F602',
        darker: '#B7F602',
        contrastText: '#000000'
      }
    }
  };

  const theme = createTheme(themeOptions);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
